import React from 'react';
import { Url } from '@wix/da-url';
export var FolderLink = function (_a) {
    var folder = _a.folder, children = _a.children, className = _a.className, onClick = _a.onClick;
    return (React.createElement("a", { onClick: onClick, className: className, href: Url.userGalleryLink({
            username: folder.owner.username,
            gallectionType: folder.type,
            folderId: folder.folderId,
            folderName: folder.name,
        }) }, children));
};
FolderLink.displayName = 'FolderLink';
export default FolderLink;
//# sourceMappingURL=FolderLink.js.map